/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * User-selectable caption text colors (CEA-608 standard palette).
 */
export enum ClosedCaptionColor {
  White = "#FFFFFF",
  Black = "#000000",
  Red = "#FF0000",
  Green = "#00FF00",
  Blue = "#0000FF",
  Yellow = "#FFFF00",
  Cyan = "#00FFFF",
  Magenta = "#FF00FF"
}
